import { render, staticRenderFns } from "./offawed.vue?vue&type=template&id=4643d7f7&scoped=true"
import script from "./offawed.vue?vue&type=script&lang=js"
export * from "./offawed.vue?vue&type=script&lang=js"
import style0 from "./offawed.vue?vue&type=style&index=0&id=4643d7f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643d7f7",
  null
  
)

export default component.exports